import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import "./index.scss";
import App from "./components/app";
import PerfectScrollbar from "react-perfect-scrollbar";
import { ToastContainer } from "react-toastify";
import { store } from "./store";
import Dashboard from "./components/dashboard";
import Orders from "./components/sales/orders";
import Transactions_sales from "./components/sales/transactions-sales";
import List_user from "./components/users/list-user";
import Create_user from "./components/users/create-user";
import Profile from "./components/settings/profile";
import Login from "./components/auth/login";
import AdminRoute from "./components/PrivateRoutes/adminRoute";
import List_product from "./components/products/list-product";
import Create_product from "./components/products/create.product";
import UserProfileDetails from "./components/users/user-profile-details";
import FundsManagement from "./components/fundManagement/funds";
import InventoryManagement from "./components/inventoryManagement";
import DepositeManagement from "./components/deposite/index";
import TeamManagement from "./components/teamManagement/TeamManagement";
import AddTeam from "./components/teamManagement/addTeam";
import UpdateTeam from "./components/teamManagement/updateTeam";
import ActivityLogList from "./components/activityLog/index";
import Bill from "./components/deposite/bill";
import { adminInstance } from "./config/axios";
import RackBackSettings from "./components/RackBackSettings";
import CompareProductPrice from "./components/products/compare.product.js";
import SupportChat from "./components/supportChat/index.jsx";
import Transactions from "./components/Transaction/transaction.jsx";
import GameTransactions from "./components/GameHistory/gameTransaction.jsx";
// import HouseEdgeSettings from './components/HouseEdgeSettings/index.js';
import AffiliateUserManagement from "./components/affiliate/affiliateUsers.js";
import AffiliateStats from "./components/affiliate/affiliatestats.js";
import List_rake_inventory from "./components/products/rakeInventoryList.js";
import GenerateAffiliateLineSection from "./components/affiliate/levelManagement.js";
import GiftCard from "./components/giftCard/index.js";
import AddGiftCard from "./components/giftCard/createCard.js";
import OnlineUsers from "./components/onlineUsers/index.js";
import Giveaway from "./components/giveaway/index.js";
import AddGiveaway from "./components/giveaway/create-giveaway.js";
import GiveawayDetails from "./components/giveaway/giveAwayDetails.js";
import RestrictedCountry from "./components/RegionRestriction/index.js";
import AddCountry from "./components/RegionRestriction/addCountry.js";
import DepositBlacklist from "./components/DepositBlacklist/index.js";

const Root = () => {
  const [newRole, setNewRole] = useState();
  const getAdminLoginData = async () => {
    try {
      const result = await adminInstance().get("api/admin/getAdminDetails");
      const { adminDetails } = result.data || {};
      const { role } = adminDetails || [];
      if (role?.length > 0) {
        setNewRole(role);
      }
    } catch (err) {
      console.log("Error is here-->", err);
    }
  };
  useEffect(() => {
    getAdminLoginData();
  }, []);

  return (
    <Provider store={store}>
      <BrowserRouter basename={"/"}>
        <PerfectScrollbar>
          <Switch>
            <Route exact path="/" component={Login} />
            <App newRole={newRole}>
              <Route path="/dashboard" component={Dashboard} />
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readBox",
                  "writeBox",
                  "delBox",
                ].includes(r),
              ) ? (
                <AdminRoute
                  exact
                  path="/supportChatManagement"
                  component={SupportChat}
                />
              ) : (
                <AdminRoute
                  exact
                  path="/supportChatManagement"
                  component={Dashboard}
                />
              )}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readBox",
                  "writeBox",
                  "delBox",
                ].includes(r),
              ) ? (
                <AdminRoute
                  exact
                  path="/transaction/list_transaction"
                  component={Transactions}
                />
              ) : (
                <AdminRoute
                  exact
                  path="/transaction/list_transaction"
                  component={Dashboard}
                />
              )}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readBox",
                  "writeBox",
                  "delBox",
                ].includes(r),
              ) ? (
                <AdminRoute
                  exact
                  path="/game-history/list_game_history"
                  component={GameTransactions}
                />
              ) : (
                <AdminRoute
                  exact
                  path="/game-history/list_game_history"
                  component={Dashboard}
                />
              )}
              {/* House Edge Setting  Route  */}
              {/* {newRole &&
              newRole?.some((r) =>
                [
                  'suUsers',
                  'superAdmin',
                  'readCategory',
                  'writeCategory',
                  'delCategory',
                ].includes(r)
              ) ? (
                <AdminRoute
                  exact
                  path='/rake-settings'
                  component={HouseEdgeSettings}
                />
              ) : (
                <AdminRoute exact path='/rake-settings' component={Dashboard} />
              )} */}
              <AdminRoute exact path="/sales/orders" component={Orders} />
              <AdminRoute
                exact
                path="/sales/transactions"
                component={Transactions_sales}
              />
              <AdminRoute exact path="/gift-card" component={GiftCard} />
              <AdminRoute exact path="/add-gift-card" component={AddGiftCard} />
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readUsers",
                  "writeUsers",
                  "delUsers",
                ].includes(r),
              ) ? (
                <AdminRoute
                  exact
                  path="/users/list-user"
                  component={List_user}
                />
              ) : (
                <AdminRoute
                  exact
                  path="/users/list-user"
                  component={Dashboard}
                />
              )}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readProduct",
                  "writeProduct",
                  "delProduct",
                ].includes(r),
              ) ? (
                <Route
                  exact
                  path="/users/create-user"
                  component={Create_user}
                />
              ) : (
                <Route exact path="/users/create-user" component={Dashboard} />
              )}
              <AdminRoute
                exact
                path="/products/list_product"
                component={List_product}
              />
              <AdminRoute
                exact
                path="/users/online-users"
                component={OnlineUsers}
              />
              <AdminRoute
                exact
                path="/products/list_rake_inventory"
                component={List_rake_inventory}
              />
              <AdminRoute
                exact
                path="/vendors/productList"
                component={List_product}
              />
              <AdminRoute
                exact
                path="/products/create-product"
                component={Create_product}
              />
              <AdminRoute
                exact
                path="/products/compare-product-price"
                component={CompareProductPrice}
              />
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readWithdraws",
                  "writeWithdraws",
                  "delWithdraws",
                ].includes(r),
              ) ? (
                <AdminRoute
                  exact
                  path="/funds-management"
                  component={FundsManagement}
                />
              ) : (
                <AdminRoute
                  exact
                  path="/funds-management"
                  component={Dashboard}
                />
              )}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readOrders",
                  "writeOrders",
                  "delOrders",
                ].includes(r),
              ) ? (
                <AdminRoute
                  exact
                  path="/order-management"
                  component={InventoryManagement}
                />
              ) : (
                <Route path="/order-management" component={Dashboard} />
              )}
              {newRole &&
              newRole?.some((r) => ["suUsers", "superAdmin"].includes(r)) ? (
                <AdminRoute
                  exact
                  path="/team-management"
                  component={TeamManagement}
                />
              ) : (
                <AdminRoute
                  exact
                  path="/team-management"
                  component={Dashboard}
                />
              )}
              {newRole && newRole?.some((r) => ["superAdmin"].includes(r)) ? (
                <AdminRoute exact path="/addTeam" component={AddTeam} />
              ) : (
                <AdminRoute exact path="/addTeam" component={Dashboard} />
              )}
              {newRole && newRole?.some((r) => ["superAdmin"].includes(r)) ? (
                <AdminRoute exact path="/updateTeam" component={UpdateTeam} />
              ) : (
                <AdminRoute exact path="/updateTeam" component={Dashboard} />
              )}
              <AdminRoute
                exact
                path="/settings"
                component={Profile}
                // pathName={window.location.pathname}
                // newRole={newRole}
              />
              {/* } */}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readProfile",
                  "writeProfile",
                  "delProfile",
                ].includes(r),
              ) ? (
                <AdminRoute
                  exact
                  path="/user-profile-details"
                  component={UserProfileDetails}
                />
              ) : (
                <AdminRoute
                  exact
                  path="/user-profile-details"
                  component={Dashboard}
                />
              )}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readActivityLog",
                  "writeActivityLog",
                  "delActivityLog",
                ].includes(r),
              ) ? (
                <AdminRoute
                  exact
                  path="/activityLog"
                  component={ActivityLogList}
                />
              ) : (
                <AdminRoute exact path="/activityLog" component={Dashboard} />
              )}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readDelivery",
                  "writeDelivery",
                  "delDelivery",
                ].includes(r),
              ) ? (
                <AdminRoute
                  exact
                  path="/rackBackSettings"
                  component={RackBackSettings}
                />
              ) : (
                <AdminRoute
                  exact
                  path="/rackBackSettings"
                  component={Dashboard}
                />
              )}
              <AdminRoute
                exact
                path="/deposite-mangement"
                component={DepositeManagement}
              />
              <AdminRoute exact path="/deposite-details" component={Bill} />
              <AdminRoute
                exact
                path="/affiliate-users"
                component={AffiliateUserManagement}
              />
              <AdminRoute
                exact
                path="/affiliate-stats"
                component={AffiliateStats}
              />
              <AdminRoute
                exact
                path="/generate-affiliate-link"
                component={GenerateAffiliateLineSection}
              />
              <AdminRoute
                exact
                path="/giveaway-management"
                component={Giveaway}
              />
              <AdminRoute
                exact
                path="/create-giveaway"
                component={AddGiveaway}
              />
              <AdminRoute
                exact
                path="/giveaway-details"
                component={GiveawayDetails}
              />

              <AdminRoute
                exact
                path="/region-restriction"
                component={RestrictedCountry}
              />
              <AdminRoute exact path="/add-country" component={AddCountry} />
              <AdminRoute
                exact
                path="/deposit-blacklist"
                component={DepositBlacklist}
              />
            </App>
          </Switch>
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </PerfectScrollbar>
      </BrowserRouter>
    </Provider>
  );
};

ReactDOM.render(<Root />, document.getElementById("root"));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
